import { Routes } from '@angular/router';
import { SharedLayoutComponent } from './shared/layouts/shared-layout/shared-layout.component';
import { authenticationGuard } from './core/guards/authentication.guard';

export const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes')
    },
    {
        path: 'trading',
        loadChildren: () => import('./trading/trading.routes'),
        canMatch: [
            authenticationGuard
        ]
    },
    {
        path: '**',
        redirectTo: 'trading'
    }
];
